
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import Pagination from "@components/base/pagination/CenterPagination.vue";
@Component({
	name: "Order",
	components: { Pagination }
})
export default class Order extends Vue {
	@Action("good/getOrderList") private getOrderList: any;
	@Action("good/withdraw") private withdrawMoney: any;
	@Action("good/pay") private payMoney: any;
	@Action("good/deleteOrder") private deleteOrder: any;
	@Action("good/getGoodData") private getGoodData: any;
	@Action("good/createGoodData") private createGoodData: any;
	@Action("good/updateGood") private updateGood: any;
	$route: any;
	id: any = this.$store.state.account.id;
	currentPage = 0;
	pages = 0;
	currentSize = 10;
	total = 0;
	current = 1;
	tableData = [];
	// search({ orderNumber }: any) {
	//   const options = { orderNumber };
	//   this.$store.dispatch('service/searchList', options).then((data: any) => {

	//   })
	// }
	confirm(row: any) {
		const options = {
			orderId: row.orderNumber,
			status: 7
		};
		this.updateGood(options).then(({ code, data, msg }: any) => {
			if (code === 0) {
				this.getData();
				this.$message.success("确认服务完成成功");
			} else {
				this.$message.error("确认服务完成失败");
			}
		});
	}
	deleteGood({ orderNumber }: any) {
		this.deleteOrder(orderNumber).then(({ code, data, msg }: any) => {
			if (code === 0) {
				this.getData();
				return this.$message.success("删除订单成功");
			}
			return msg;
		});
	}
	pay({ orderNumber, stater }: any) {
		// const { declareId, money,userId = this.id, payTerrace = '支付宝', payTitle, payBody } = item;
		// if(stater===0) {
		//   return this.$message.warning("该商品已下架")
		// }
		const loading = this.$loading({
			lock: true,
			text: "Loading",
			spinner: "el-icon-loading",
			background: "rgba(0, 0, 0, 0.7)"
		});
		const returnUrl = location.href;
		this.payMoney({ orderId: orderNumber, returnUrl })
			.then(({ request }: any) => {
				if (request) {
					const { response } = request;
					let divForm = document.getElementsByTagName("div");
					if (divForm.length) {
						document.body.removeChild(divForm[0]);
					}
					const div = document.createElement("div");
					div.innerHTML = response; // data就是接口返回的form 表单字符串
					document.body.appendChild(div);
					// document.forms[0].setAttribute('target', '_blank') // 新开窗口跳转
					document.forms[0].submit();
				}
			})
			.finally(() => loading.close());
	}
	withdraw({ orderNumber, money, payTerrace }: any) {
		this.$prompt("请输入退款原因", "提示", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			inputPattern: /^[\u4E00-\u9FA5A-Za-z(),， ]{2,40}$/,
			inputErrorMessage: "请输入中文(至少2字)"
		})
			.then(({ value: reason }: any) => {
				const options = {
					orderNumber,
					money,
					reason
				};
				if (!reason) {
					return this.$message.warning("请输入退款原因");
				}
				this.toWithDraw(options);
			})
			.catch(() => {
				this.$message({
					type: "info",
					message: "取消退款"
				});
			});
	}
	toWithDraw(options: any) {
		const loading = this.$loading({
			lock: true,
			text: "Loading",
			spinner: "el-icon-loading",
			background: "rgba(0, 0, 0, 0.7)"
		});
		setTimeout(() => {
			loading && loading.close();
		}, 30000);
		this.withdrawMoney(options).then(({ code, data, msg }: any) => {
			loading && loading.close();
			if (code === 0) {
				this.getData();
				return this.$message.success("申请退款成功");
			}
			return false;
		});
	}
	toPay(item: any) {
		const { stater, goodsId: goodId } = item;

		this.$router.push({
			path: "/detail/market",
			query: { goodId }
		});
	}
	btnList = [
		{
			title: "待付款",
			src: require("@images/icon/3.png"),
			active: require("@images/icon/3-active.png"),
			value: 0
		},
		{
			title: "已付款",
			src: require("@images/icon/1.png"),
			active: require("@images/icon/1-active.png"),
			value: 1
		},
		{
			title: "退款中",
			src: require("@images/icon/2.png"),
			active: require("@images/icon/2-active.png"),
			value: 2
		},
		{
			title: "已退款",
			src: require("@images/icon/2.png"),
			active: require("@images/icon/2-active.png"),
			value: 4
		},
		{
			title: "拒绝退款",
			src: require("@images/icon/2.png"),
			active: require("@images/icon/2-active.png"),
			value: -4
		},
		{
			title: "退款失败",
			src: require("@images/icon/2.png"),
			active: require("@images/icon/2-active.png"),
			value: -2
		},
		{
			title: "已超时",
			src: require("@images/icon/2.png"),
			active: require("@images/icon/2-active.png"),
			value: 3
		},
		// {
		// 	title: "已作废",
		// 	src: require("@images/icon/2.png"),
		// 	active: require("@images/icon/2-active.png"),
		// 	value: -2
		// },
		// {
		// 	title: "待审核",
		// 	src: require("@images/icon/2.png"),
		// 	active: require("@images/icon/2-active.png"),
		// 	value: -3
		// },
		// {
		// 	title: "待服务",
		// 	src: require("@images/icon/2.png"),
		// 	active: require("@images/icon/2-active.png"),
		// 	value: -5
		// },
		{
			title: "卖家开始服务",
			src: require("@images/icon/2.png"),
			active: require("@images/icon/2-active.png"),
			value: 5
		},
		{
			title: "卖家服务结束",
			src: require("@images/icon/2.png"),
			active: require("@images/icon/2-active.png"),
			value: 6
		},
		{
			title: "买家确认服务完成",
			src: require("@images/icon/2.png"),
			active: require("@images/icon/2-active.png"),
			value: 7
		}
		// {
		//   title: '完成',
		//   src: require('@images/icon/2.png'),
		//   active: require('@images/icon/2-active.png'),
		//   value: 4,
		// },
	];
	created() {
		this.getData();
	}
	getData() {
		const options = {
			current: this.current,
			size: this.currentSize,
			state: this.btnList[this.currentPage].value,
			userId: this.id
		};

		this.getOrderList(options).then((res: any) => {
			const { code, data, msg } = res;
			if (code === 0) {
				const { records, total, pages } = data;
				const map = new Map();
				this.btnList.map((item: any) => {
					map.set(item.value, item.title);
					return item;
				});
				this.tableData = records.map((item: any) => {
					item.state = map.get(item.stater);
					return item;
				});
				this.total = total;
				this.pages = pages;
				return data;
			}
			return res.data;
		});
	}
	changeTab(index: any) {
		this.currentPage = index;
		this.current = 1;
		this.getData();
	}
	currentChange(param: number) {
		this.current = param;
		this.getData();
	}
	handleSizeChange(val: any) {}
	handleCurrentChange(val: any) {
		this.current = val;
		this.getData();
	}
}
